import { Classroom } from "@/models/classrooms.model";
import { Course } from "@/models/courses.model";
import { Pagination, QueryParams } from "@/models/query-params.model";
import { ClassesRest } from "@/services/rest/classes.rest";
import { CoursesRest } from "@/services/rest/courses.rest";
import { BehaviorSubject, take } from "rxjs";

export class CalendarService {
  constructor(
    private _courses = new CoursesRest(),
    private _classes = new ClassesRest()
  ) {}

  private $courses = new BehaviorSubject({} as Pagination<Course>);
  courses = this.$courses.asObservable();
  private $classes = new BehaviorSubject({} as Pagination<Classroom>);
  classes = this.$classes.asObservable();
  getCourses(params: QueryParams) {
    this._courses
      .getCourses(params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.$courses.next(response);
        },
      });
  }
  getClassrooms(params: QueryParams) {
    this._classes
      .getAllClasses(params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.$classes.next(response);
        },
      });
  }
}
